import { makeStyles, createStyles } from '@material-ui/core'

export const useCarouselModalStyles = makeStyles((theme) =>
  createStyles({
    closeButton: {
      position: 'absolute',
      right: 0,
      top: '8%',
      zIndex: theme.zIndex.drawer + 1,
      padding: 10,
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      [theme.breakpoints.down(960)]: {
        right: '1%',
        top: '1%',
        padding: 6,
        backgroundColor: 'rgba(0, 0, 0, 0.4)'
      }
    },

    closeIcon: {
      fontSize: theme.spacing(5),
      [theme.breakpoints.down(960)]: {
        fontSize: theme.spacing(4)
      }
    },

    swiperContainer: {
      width: '70%',
      height: '100vh',
      '--swiper-navigation-color': '#fff',
      '--swiper-pagination-color': '#fff',
      [theme.breakpoints.down(1280)]: {
        width: '90%'
      },
      [theme.breakpoints.down(960)]: {
        width: '100%',
        height: '100%'
      }
    },

    sliderZoomContainer: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      position: 'relative'
    },

    slide: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      marginTop: 'auto',
      marginBottom: 'auto',
      overflow: 'hidden'
    },

    img: {
      maxWidth: '87%',
      maxHeight: '100vh',
      objectFit: 'contain',
      [theme.breakpoints.down(960)]: {
        maxWidth: '100%'
      },
      [theme.breakpoints.down(600)]: {
        maxHeight: 600
      }
    }
  })
)
